export const SITE_NAME = "UPS Technology";

export const SITE_SLOGAN = {
  cs: "Vaše jistota energie již 34 let",
  en: "Your energy security for 34 years",
  uk: "Ваша енергетична безпека протягом 34 років",
};
